import React from "react";

interface TextEditProps {
  id: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  placeholder?: string;
  error?: string;
  type?: "text" | "email" | "password" | "tel";
  className?: string;
}

export function TextEdit({
  id,
  name,
  value,
  onChange,
  label,
  placeholder,
  error,
  type = "text",
  className = "",
}: TextEditProps) {
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-xs font-medium text-gray-500 mb-1"
      >
        {label}
      </label>
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`block w-full rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2.5 px-3 ${className}`}
        placeholder={placeholder}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
